import { sprintf } from 'sprintf-js';

import { Text } from 'components/Text/Text';
import { SearchLoadingSectionLine } from 'modules/search/components/Loading/SearchLoadingSectionLine';

type Props = {
  count: number | undefined;
};

export function SearchResultsHeaderCount({ count }: Props) {
  if (typeof count === 'undefined')
    return <SearchLoadingSectionLine width={64} height={20} />;

  const text =
    count === 1
      ? getText('1 result')
      : sprintf(getText('%(count)s results'), {
          count,
        });

  return (
    <Text
      tag="h2"
      styleAs="body"
      display={['block', 'block', 'block', 'inline-block']}
      fontSize="16px!important"
      mb={0}
      data-qa-id="result-count"
      data-result-count={count}
    >
      {text}
    </Text>
  );
}
